import { Reset } from "@/modules/auth/components";

export const ResetPasswordPage = () => {
  return <Reset />;
};
